import { put, takeLatest, all } from 'redux-saga/effects'
import { api, exportApi, nodeApi } from '../../service/apiService'
import {
    getDivision, getDistrict, getLocation, getStore,
    getStoreByDistrict, getSearchResultCurrent, exportToExcel,
    getRoleBasedDetails,
    getSubscriptionKey, getUserSFKeyMap, getIssues, getAccessDetail,
    getSource, getCategory, getStatus, getCommentType
} from '../../service/apiUrls';
import { authTokenCookie } from '../../utils/CookieMaker';
import { userRole } from '../../utils/constants'
import { formSelectData, formAutoCompleteData, formatDetails, fileNameBuilder } from '../../utils/utils'
import { serviceInProgress } from '../../component/containers/loader/LoaderAction';
import {
    setRole, GET_ROLE, setDetails, GET_DETAILS,
    GET_DIVISION, GET_DISTRICT, GET_STORE, GET_LOCATION,
    setDivision, setDistrict, setStore, setLocation, setStoreByDistrict,
    GET_STORE_DISTRICT, GET_SEARCHRESULT, setSearchResult, GET_EXPORTTOEXCEL, GET_APIMKEY, setAPIMKey,
    GET_USERSFKEYMAP, setUserSFKeyMap, GET_ISSUES, setIssues, GET_ACCESSDETAILS, setAccessDetails,
    GET_SOURCE, GET_CATEGORY, GET_STATUS, GET_COMMENTTYPE,
    setSource, setCategory, setStatus, setCommentType
} from '../../component/screens/customerComments/customerCommentsAction'
// import { GET_CASE_ID_FORM, GET_CLOSE_CONTACT, GET_SAVE_NOT_CLOSED, setCaseIdForm, setCloseContact, setSaveNotClosed, setContact, setPosition, GET_CONTACT, GET_POSITION } from '../../component/containers/ctlWebForm/ctlWebFormAction'
import { call, select } from 'redux-saga/effects';
import * as selectors from './selectors';
// import {ctlWebData} from '../../utils/constants'
// import { SERVICE_ERROR, SERVICE_EXCEPTION, serviceError, serviceException } from '../../common/ServiceError/ServiceErrorAction';
import { serviceError } from '../../common/ServiceError/ServiceErrorAction';
import moment from 'moment'

function exceptionFormatter(exp) {
    if (exp.config) {
        return { message: "System is unable to process this request at the moment, please contact the System Administrator." }
    }
    else return { exp, url: ``, method: `` }
}

function isJWTNotExpired() {
    let tokenNotExpired = true;
    let currentDate = new Date();
    let currentTime = currentDate.getTime();
    let { decodedIdToken, authCookie, userInfo } = authTokenCookie();
    // JWT exp is in seconds
    let sessionId = sessionStorage.getItem('sessionId')
    console.log(decodedIdToken.exp * 1000, currentTime, `cookie-currenttime`);
    if (authCookie.name && sessionId === userInfo.userId) {
        let tokenExpiry = decodedIdToken.exp * 1000;
        if (tokenExpiry < currentTime) {
            tokenNotExpired = false;
        }
    }
    return tokenNotExpired;
}

function* get_UserSFKeyMap(requestData) {
    try {
        let defaultDivision = [`98`, `96`, `99`, `00`, `97`];
        const { userInfo } = authTokenCookie();

        let userDefData
        let userRole = requestData?.ctlPriorityData?.appUserRole;
        if(userRole === 'DivisionUser'){
              userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
            userDefData =(userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision))? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData
        }else  if(userRole === 'DistrictUser'){
             userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
            userDefData =(userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision))? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData;

            userDefData = userInfo && userInfo.userDistrict && Array.isArray(userInfo.userDistrict) ? { ...userDefData, "swyDistrict": userInfo.userDistrict } :
            (userInfo && userInfo.userDistrict ? { ...userDefData, "swyDistrict": [userInfo.userDistrict] } : userDefData)
            
        }else  if(userRole === 'StorePharmacyUser' || userRole === 'StoreUser'){
             userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
            userDefData =(userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision))? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData
            userDefData = userInfo && userInfo.userDistrict && Array.isArray(userInfo.userDistrict) ? { ...userDefData, "swyDistrict": userInfo.userDistrict } :
                (userInfo && userInfo.userDistrict ? { ...userDefData, "swyDistrict": [userInfo.userDistrict] } : userDefData)
            userDefData = userInfo && userInfo.userStore && Array.isArray(userInfo.userStore) ? { ...userDefData, "swyFacilityCode": userInfo.userStore } :
                (userInfo && userInfo.userStore ? { ...userDefData, "swyFacilityCode": [userInfo.userStore] } : userDefData);
            
        }else{
             userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
        }

        // let userDefData = userInfo ? { "roleUserName": userInfo.userId } : ``;
        // userDefData = (userInfo.userDivision && !defaultDivision.includes(userInfo.userDivision)) ? { ...userDefData, "swyDivision": userInfo.userDivision } : userDefData
        // userDefData = userInfo && userInfo.userDistrict && Array.isArray(userInfo.userDistrict) ? { ...userDefData, "swyDistrict": userInfo.userDistrict } :
        //     (userInfo && userInfo.userDistrict ? { ...userDefData, "swyDistrict": [userInfo.userDistrict] } : userDefData)
        // userDefData = userInfo && userInfo.userStore && Array.isArray(userInfo.userStore) ? { ...userDefData, "swyFacilityCode": userInfo.userStore } :
        //     (userInfo && userInfo.userStore ? { ...userDefData, "swyFacilityCode": [userInfo.userStore] } : userDefData);
        if (isJWTNotExpired()) {
            let subKey = yield select(selectors.key);
            let response = yield call(() => { return api(getUserSFKeyMap.url, getUserSFKeyMap.method, userDefData, subKey) });
            let keyMap = response && response.data;
            let modifiedData
            if (keyMap) {
                modifiedData = formatDetails(response.data, response.status)
            }

            yield put(setUserSFKeyMap(modifiedData));
        }
    } catch (exp) {
        console.log(`UserKeyMap Exp`, exp);
    }
}

function* get_SubKey() {
    try {
        let response = yield call(() => { return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method) });
        // let response = yield call(() => { return nodeApi(`https://svwp-ctl-ui-dev.apps.np.stratus.albertsons.com/api/getSubKey`,`GET`) });
        let key = response && response.data && response.data.subKey;
        yield put(setAPIMKey(key));
    }
    catch (exp) {
        console.log(`APIM Key exception`, exp);
    }
};


function* get_division() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getDivision.url, getDivision.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formSelectData('Select Division', dataTest.data)
            }
            yield put(setDivision(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_issues() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getIssues.url, getIssues.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setIssues(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_source() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getSource.url, getSource.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setSource(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_location() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getLocation.url, getLocation.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setLocation(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_category() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getCategory.url, getCategory.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setCategory(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_status() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getStatus.url, getStatus.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setStatus(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_commenttype() {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getCommentType.url, getCommentType.method, ``, subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData('Select All', dataTest.data)
            }

            yield put(setCommentType(data))

            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_Role() {
    try {
        yield put(serviceInProgress(true));
        const data = userRole;
        yield put(setRole(data))
        yield put(serviceInProgress(false));
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

// function* get_CaseId_Form(caseId) {
//     try {
//         if (isJWTNotExpired()) {
//             yield put(serviceInProgress(true));
//             // let urlName = caseId.edm ? getCaseIdFormArchive : getCaseIdForm
//             // JWTExpirationCheck();
//             let subKey = yield select(selectors.key);
//             let dataTest = yield call(() => { return api(`${getCaseIdForm.url}${caseId.payload}`, getCaseIdForm.method, ``, subKey) })
//             let data;
//             if (dataTest) {
//                 data = caseIdFormData(dataTest.data);
//             }
//             // const data = ctlWebData;
//             yield put(setCaseIdForm(data))
//             if (data)
//                 yield put(serviceInProgress(false));
//         }
//     }
//     catch (exp) {
//         yield put(serviceInProgress(false));
//         yield put(serviceError(exceptionFormatter(exp)));
//     }
// }
function* get_Details(role) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let data = yield call(() => { return api(`${getRoleBasedDetails.url}`, getRoleBasedDetails.method, '', subKey) })
            yield put(setDetails(data.data[0]))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_district(divId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));

            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getDistrict.url + divId.payload, getDistrict.method, '', subKey) })
            let data
            if (dataTest) {
                data = formAutoCompleteData("Select District", dataTest.data)
            }
            yield put(setDistrict(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_SearchResult(searchObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let url = getSearchResultCurrent.url;
            let reqBody = {
                "commentTypes": searchObj.value.commentType,
                "status": searchObj.value.status,
                "categories": searchObj.value.category,
                "sources": searchObj.value.source,
                "locations": searchObj.value.location,
                "dug": searchObj.value.dug,
                "homeShopping": searchObj.value.homeShopping,
                "caseNumber": searchObj.value.contactId,
                "divisionName": searchObj.value.divisionName,
                "districtNo": searchObj.value.districtId,
                "storeNumber": searchObj.value.storeId,
                "openFrom": searchObj.value.fromDt,
                "openTo": searchObj.value.toDt,
                "issues": searchObj.value.issue,
                "pageNumber": searchObj.pageNo,
                "pageSize": searchObj.rowCount,
                "sortBy": searchObj.sortBy,
                "sortField": searchObj.fieldName
            }
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(url, getSearchResultCurrent.method, reqBody, subKey) })
            yield put(setSearchResult(dataTest))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
function* get_ExportToExcel(searchObj) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let url = exportToExcel.url;
            let reqBody = {
                "commentTypes": searchObj.value.commentType,
                "status": searchObj.value.status,
                "categories": searchObj.value.category,
                "sources": searchObj.value.source,
                "locations": searchObj.value.location,
                "dug": searchObj.value.dug,
                "homeShopping": searchObj.value.homeShopping,
                "caseNumber": searchObj.value.contactId,
                "divisionName": searchObj.value.divisionName,
                "districtNo": searchObj.value.districtId,
                "storeNumber": searchObj.value.storeId,
                "openFrom": searchObj.value.fromDt,
                "openTo": searchObj.value.toDt,
                "issues": searchObj.value.issue,
                "pageNumber": searchObj.pageNo,
                "pageSize": searchObj.rowCount,
                "sortBy": searchObj.sortBy,
                "sortField": searchObj.fieldName
            }
            let fileNameObj = {
                divisionName: searchObj.value.divisionName,
                districtNo: searchObj.value.districtId,
                storeNumber: searchObj.value.storeId,
                caseNumber: searchObj.value.contactId,
                openFrom: moment(searchObj.value.fromDt).format('MM-DD-YYYY'),
                openTo: moment(searchObj.value.toDt).format('MM-DD-YYYY'),
            }
            let fileName = fileNameBuilder(fileNameObj)
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return exportApi(url, exportToExcel.method, reqBody, subKey) })
            if (dataTest) {
                var blob = new Blob([dataTest.data], { type: 'application/xlsx' });
                var link = document.createElement('a');
                var fileURL = window.URL.createObjectURL(blob);
                link.href = fileURL;
                link.download = `${fileName}_CustomerComments.xlsx`;
                link.target = '_blank';
                link.click();
                //  return true;
            }
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* get_store(divId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true))
            let subKey = yield select(selectors.key)
            let dataTest = yield call(() => { return api(getStore.url + divId.payload, getStore.method, '', subKey) })
            let data;
            if (dataTest) {
                data = formAutoCompleteData("Select Store", dataTest.data)
            }
            yield put(setStore(data))
            yield put(serviceInProgress(false))
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false))
        yield put(serviceError(exceptionFormatter(exp)))
    }
}

function* get_store_byDistrict(disId) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            let subKey = yield select(selectors.key);
            let dataTest = yield call(() => { return api(getStoreByDistrict.url + disId.payload, getStoreByDistrict.method, '', subKey) })
            let data
            if (dataTest) {
                data = formAutoCompleteData("Select Store", dataTest.data)
            }
            yield put(setStoreByDistrict(data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)))
    }
}



// function* close_Contact(reqObj) {
//     try {
//         if (isJWTNotExpired()) {
//             yield put(serviceInProgress(true));
//             // JWTExpirationCheck();
//             let subKey = yield select(selectors.key);
//             let dataTest = yield call(() => { return api(`${closeContact.url}${reqObj.caseId}`, closeContact.method, reqObj.value, subKey) })

//             yield put(setCloseContact(dataTest))
//             yield put(serviceInProgress(false));
//         }
//     }
//     catch (exp) {
//         yield put(serviceInProgress(false));
//         yield put(serviceError(exceptionFormatter(exp)));
//     }
// }

// function* save_not_Closed(reqObj) {
//     try {
//         if (isJWTNotExpired()) {
//             yield put(serviceInProgress(true));
//             // JWTExpirationCheck();
//             let subKey = yield select(selectors.key);
//             let dataTest = yield call(() => { return api(`${saveNotClosed.url}${reqObj.caseId}`, saveNotClosed.method, reqObj.value, subKey) })
//             yield put(setSaveNotClosed(dataTest))
//             yield put(serviceInProgress(false));
//         }
//     }
//     catch (exp) {
//         yield put(serviceInProgress(false));
//         yield put(serviceError(exceptionFormatter(exp)));
//     }
// }

// function* get_Contacts() {
//     try {
//         if (isJWTNotExpired()) {
//             yield put(serviceInProgress(true));
//             // JWTExpirationCheck();
//             let subKey = yield select(selectors.key);
//             let dataTest = yield call(() => { return api(contacts.url, contacts.method, ``, subKey) })
//             let data;
//             if (dataTest) {
//                 data = formSelectData('Select Result', dataTest.data)
//             }
//             yield put(setContact(data))
//             yield put(serviceInProgress(false));
//         }
//     }
//     catch (exp) {
//         yield put(serviceInProgress(false));
//         yield put(serviceError(exceptionFormatter(exp)));
//     }
// }
function* get_AccessDetails(userInfo) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            let subKey = yield select(selectors.key);
            if (subKey === undefined) {
                // JWTExpirationCheck();
                let response = yield call(() => { return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method) });
                subKey = response && response.data && response.data.subKey;
            }
            let userNameRole = [];
            
            userInfo?.value?.allUserRole.forEach((userRole, index) => {
                if(userRole === 'StorePharmacyUser' || userRole === 'StoreUser'){
                    userNameRole.push('StoreUser')
                }else if(userRole === 'CSCUser' || userRole === 'BackstageNonCSCUser' || userRole === 'SuperAdmin' || userRole === 'AssetProtectionUser'){
                    userNameRole.push('CSCUser')
                }else{
                    userNameRole.push(userRole)
                }
            })
           
            let request = {
                "userNameRole": userNameRole.join(`;`),
                "userName": userInfo?.value?.userId
            }
            let res = yield call(() => { return api(getAccessDetail.url, getAccessDetail.method, request, subKey) })
            yield put(setAccessDetails(res?.data))
            authTokenCookie(res?.data?.allAppDet)
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}
// function* get_Positions() {
//     try {
//         if (isJWTNotExpired()) {
//             yield put(serviceInProgress(true));
//             // JWTExpirationCheck();
//             let subKey = yield select(selectors.key);
//             let dataTest = yield call(() => { return api(positions.url, positions.method, ``, subKey) })
//             let data;
//             if (dataTest) {
//                 data = formSelectData('Select Contacting Employee Position', dataTest.data)
//             }
//             yield put(setPosition(data))
//             yield put(serviceInProgress(false));
//         }
//     }
//     catch (exp) {
//         yield put(serviceInProgress(false));
//         yield put(serviceError(exceptionFormatter(exp)));
//     }
// }

function* Watcher() {
    yield takeLatest(GET_APIMKEY, get_SubKey);
    yield takeLatest(GET_ACCESSDETAILS, get_AccessDetails);
    yield takeLatest(GET_USERSFKEYMAP, get_UserSFKeyMap);
    yield takeLatest(GET_DIVISION, get_division);
    yield takeLatest(GET_ISSUES, get_issues);
    yield takeLatest(GET_DISTRICT, get_district);
    yield takeLatest(GET_STORE, get_store);
    yield takeLatest(GET_STORE_DISTRICT, get_store_byDistrict);
    yield takeLatest(GET_LOCATION, get_location);
    yield takeLatest(GET_ROLE, get_Role);
    yield takeLatest(GET_DETAILS, get_Details);
    yield takeLatest(GET_SEARCHRESULT, get_SearchResult);
    yield takeLatest(GET_EXPORTTOEXCEL, get_ExportToExcel);
    yield takeLatest(GET_SOURCE, get_source);
    yield takeLatest(GET_CATEGORY, get_category);
    yield takeLatest(GET_STATUS, get_status);
    yield takeLatest(GET_COMMENTTYPE, get_commenttype);


}
// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        Watcher()])
}